import { render } from "./boost-analytics.vue?vue&type=template&id=75da8862"
import script from "./boost-analytics.vue?vue&type=script&lang=js"
export * from "./boost-analytics.vue?vue&type=script&lang=js"

import exportComponent from "/buddy/derek-lam-1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__